<template>
	<div>
		<div class="product-image-div">
			<img class="home-bg-img" :src="xgTheme.homeBgImage" />
			<div class="user-info-div flex-between">
				<div class="mobile-div flex_center">
					<div class="f-s-17 w-550 somber">{{xgUserInfo.mobile|mobile}}</div>
					<div class="f-s-12 light-gray p-4" @click="toLogin">
						<van-icon name="exchange">更换账号</van-icon>
					</div>
				</div>
				<div class="score-div flex_center">
					<div class="f-s-14" v-if="xgUserInfo.isImpower == 0">
						<div class="gray">我的移动积分:</div>
						<div class="link" @click="autoAuth()">请先授权查询></div>
					</div>
					<div v-if="xgUserInfo.isImpower == 1">
						<div class="f-s-14 p-t-3 gray" v-if="xgUserInfo.cyScore>0">
							畅由积分:<span class="pink">{{xgUserInfo.cyScore}}</span>
						</div>
						<div class="f-s-14 gray">
							我的移动积分:<span class="brownness">{{xgUserInfo.cmccScore}}</span>
						</div>
						<div class="f-s-12 gray">
							(可兑换{{xgUserInfo.cmccScore|toCyScore}}畅由积分)
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="btn-div">
			<Option :color="xgTheme.homeOptionColor" :bgColor="xgTheme.homeOptionBgColor"></Option>
		</div>

		<van-popup v-model="showAuthModel" closeable>
			<Auth></Auth>
		</van-popup>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	import {
		getCmccPower,
		getUpLimit,
		getPkParamStr
	} from '@/request/api';
	import Auth from './Auth.vue'
	import Option from './Option.vue'
	export default {
		name: 'UserInfo',
		computed: mapGetters(['xgUserInfo', 'xgTheme']),
		components: {
			[Auth.name]: Auth,
			[Option.name]: Option
		},
		created() {
			this.init()
		},
		data() {
			return {
				head: require('../../assets/head.png'),
				showAuthModel: false,
				callbackUrl: 'https://jf.ydong.com.cn#/home',
				// callbackUrl: 'http://localhost:8080#/home',
				baseUrl: 'https://m.changyoyo.com/event/2019/blankPage/index.html?',

			}
		},
		props: {
			count: {
				type: Number,
				default: 0
			}
		},
		watch: {
			count: {
				immediate: true,
				handler(val) {
					if (val > 0) {
						this.autoAuth()
					}
				}
			}
		},
		methods: {
			...mapMutations(['xsIsImpower', 'xsCmccScore', 'xsCyScore', 'xsIsChangeAccount']),
			init() {
				this.getCmccPower()
			},
			toBack() {
				this.$router.go(-1);
			},
			getCmccPower() {
				getCmccPower({

				}).then(res => {
					if (res.isImpower == 1) {
						//无需授权
						this.xsIsImpower(1)
						this.xsCmccScore(res.cmccScore)
						this.xsCyScore(res.cyScore)
						//积分上线检测
						this.getLimit()
					} else {
						this.autoAuth()
					}
				})
			},
			autoAuth() {
				getPkParamStr({
					callbackUrl: this.callbackUrl
				}).then(res => {
					this.authUrl = this.baseUrl + res
					let uri = window.location.href.split("#")[0]
					if (!uri.includes('resultCode')) {
						window.location = this.authUrl
					}
				})
			},
			getLimit() {
				getUpLimit({

				}).then(res => {
					if (res == true) {
						this.$router.replace("empty");
					}
				})
			},
			toLogin() {
				this.xsIsChangeAccount(true);
				this.$router.replace("/");
			}
		}
	}
</script>

<style scoped>
	.home-bg-img {
		width: 100%;
		height: 250px;
		position: absolute;
		top: 0px;
		left: 0px;
		z-index: 1;
	}

	.mobile-div {
		flex: 4;
	}

	.score-div {
		flex: 3;
	}

	.user-info-div {
		width: calc(100% - 20px);
		background-color: #ffffff;
		height: 80px;
		padding: 5px;
		position: absolute;
		border-radius: 5px;
		top: 200px;
		left: 10px;
		z-index: 1;
	}

	.product-image-div {
		width: 100%;
		height: 280px;
		padding-bottom: 50px;
	}

	.head-div {
		width: 100px;
		padding: 15px;
	}

	.head-div img {
		width: 100%;
	}

	.detail-div {
		padding: 15px 0;
		flex: 1;
	}

	.btn-div {
		width: 80px;
		text-align: right;
		padding-top: 15px;
		position: absolute;
		top: 30px;
		right: 0px;
		z-index: 1;
	}
</style>
